export default __webpack_public_path__ + "static/octanner-c28743c9ed215ceeca3b89d1f9ba2194.jpg";